import React from "react";

export function RedDot() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      fill="none"
      viewBox="0 0 18 19"
    >
      <circle cx="8.794" cy="9.463" r="8.743" fill="#b4005f"></circle>
    </svg>
  );
}
